// extracted by mini-css-extract-plugin
module.exports = {"containerMain":"styles_containerMain__1ueyz","popupBackground":"styles_popupBackground__1E5H4"};